export default "/images/st2.jpg?e827bc3b74291d950f6e000c344e2090";